<template>
	<b-input-group>
		<b-form-input
			id="input-url"
			v-model="url"
			size="sm"
			placeholder="Enter image url"
		/>
		<input
			ref="fileInput"
			type="file"
			hidden
			accept="image/*"
			@change="uploadFile($event)"
		>
		<b-input-group-append>
			<b-dropdown
				text="Choose"
				size="sm"
				variant="outline-secondary"
			>
				<template #button-content>
					<b-icon icon="list-task" />
				</template>
				<b-dropdown-item v-for="pic in filesInView" :key="pic.id" @click="loadImage(pic)">
					{{ pic.name }}
				</b-dropdown-item>
			</b-dropdown>
			<b-button
				size="sm"
				text="Button"
				variant="secondary"
				@click="clickInput"
			>
				<b-icon icon="upload" />
			</b-button>
		</b-input-group-append>
	</b-input-group>
</template>

<script>
export default {
    name: 'ImageUploadInput',
    filters: {},
    props: {
        imageUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            url: this.imageUrl,
            filesInView: [],
            file: '',
			uploadFileName: this.$t('file-manager.no-file-selected'),
        }
    },
    computed: {
        
    },
    watch: {
         url: {
			immediate: true,
			handler(newVal) {
                 this.$emit('update-image', newVal);
			},
		},
    },
    mounted() {
        this.getFiles();
    },
    methods: {
        async getImage(uri) {
			let image = '';
			if (uri.match(/^http.*/)) image = uri;
			if (uri.match(/^\/files\/*/)) {
				try {
					const img = await this.axios.get(`${uri}`, { responseType: 'blob' })
					image = URL.createObjectURL(img.data)
				} catch (error) {
					/* */
				}
				
			}			
			return image;
		},
		loadImage(el) {
			this.url = `/files/${el.id}`
		},
		clickInput() {
			this.$refs.fileInput.click();
		},
		checkFileHash(fileHash) {
			// Call /files/hash to determine if file is previously uploaded
			// If 204 (No Content) there is no matching file, so upload
			// If 200, the metadata of the matching file is returned, so continue as if you uploaded
			this.axios.get(`/files/hash/${fileHash}`).then((response) => {
				if (response.status === 200) {
					// 200: match; 204: no match
					// this file has already been uploaded.
					// we need a workflow as to how the user should be notified
					// for now, close modal and pop a toast					
					this.file = null;
					this.uploadFileName = this.$t('file-manager.no-file-selected');
					this.$bvToast.toast(this.$t('file-manager.matching-hash-description'), {
						title: this.$t('file-manager.matching-hash-title'),
						variant: 'warning',
					});
				}
			});
		},	
		uploadFile(event) {
			// Prepare file by checking hash against existing files	
			// in other components ( ElementManager/FileManager) this section is in a separate method called prepareFileUpload() )		
			[this.file] = event.target.files;
			this.uploadFileName = this.file.name;

			const fileReader = new FileReader();
			const that = this;
			fileReader.onload = function fileReaderOnload(e) {
				crypto.subtle
					.digest('SHA-256', e.target.result)
					.then((hashBuffer) => {
						const hashArray = Array.from(new Uint8Array(hashBuffer));
						that.fileHash = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('');
						that.checkFileHash(that.fileHash);
					})
					.catch((error) => {
						console.error(error);
						this.fileHash = null;
					});
			};
			fileReader.readAsArrayBuffer(this.file);
			const formData = new FormData();
			formData.append('file', this.file);
			
			// Upload file as multi-part form data
			this.axios
				.put(`/files`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.then((data) => {
					data.data.user = { ...this.$store.state.user };
					data.data.fileUri = `dmp:file:${data.data.id}`;
					this.filesInView.push(data.data);
					this.url = `/files/${data.data.id}`
					this.file = null;
					this.uploadFileName = this.$t('file-manager.no-file-selected');
					this.$bvToast.toast(this.$t('file-manager.uploaded-description'), {
						title: this.$t('file-manager.uploaded-title'),
						variant: 'success',
					});
				})
				.catch((error) => {
					console.error(error);
				});
		},			
		getFiles(searchValue = null) {
			let url = '/files/enterprise';
			const qp = new URLSearchParams();
			if (searchValue) qp.set('name', searchValue);
			url = `${url}?${qp.toString()}`;
			this.axios.get(url).then((response) => {
				this.filesInView = [];
				for (const item of response.data.filter(x=>x.type.match(/image/))) {
					this.filesInView.push(item);
				}
			});
		},
    },
}
</script>